// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Mousewheel } from 'swiper';
//import SwiperAnimation from '@cycjimmy/swiper-animation';
//import "animate.css"

const $ = window.jQuery;

const heroSwiper = {
	init() {
		const $heroSwiper = $(document).find('#heroSwiper');
		if (!$heroSwiper.length) return;

    const $slides = $heroSwiper.find('.swiper-slide');
		if (!$slides.length) return;

    if($slides.length > 1)  {
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Mousewheel]);

const swiper = new Swiper('#heroSwiper', {
  effect: 'fade',
  fadeEffect: {
    // Add this
    crossFade: true,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  cache: true,
  loop: true,
  infinit: false,
  watchOverflow: true,
  mousewheel: {
    forceToAxis: true,
  },
  autoplay: {
    delay: 6500,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});
    }
		
	},
};

export default heroSwiper;
